import axios from 'axios';
import {clearAuthData, getExpiry, getToken, initialize, isImpersonating, setToken} from '@/services/AuthService';
import router, {publicRoutes} from '@/router';
import {getApiBaseUrl} from '@/helper';

window.axios = axios;

export const myAxios = window.axios.create({
    baseURL: getApiBaseUrl(),
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    }
});

myAxios.interceptors.request.use(
    async (config) => {
        // getToken()/getExpiry() vrací token pro tento konkrétní panel - pokud panel
        // impersonuje, jde o token ze sessionStorage, jinak o běžný token z localStorage.
        const token = getToken();
        const expiry = getExpiry();
        const impersonating = isImpersonating();

        if (token) {
            const now = Math.floor(Date.now() / 1000);

            // Check if token is nearing expiration (e.g., 5 minutes before expiry)
            if (expiry && expiry - now < 300) {
                try {
                    const response = await axios.post(`${getApiBaseUrl()}/api/auth/refresh`, {}, {
                        headers: {Authorization: `Bearer ${token}`},
                    });

                    // get new token from response headers, remove Bearer
                    const newToken = response.headers.authorization.split(' ')[1];
                    // Refreshnutý token se musí vrátit do stejného úložiště, ze kterého
                    // vzešel, jinak by se impersonovaný token dostal do sdíleného
                    // localStorage a ovlivnil i ostatní panely.
                    setToken(newToken, {impersonate: impersonating, expiry: now + (process.env.VUE_APP_JWT_TTL * 60)});
                    config.headers['Authorization'] = 'Bearer ' + newToken;
                } catch (error) {

                    clearAuthData();
                    await router.push('/login') // Redirect on refresh failure
                }
            } else {
                config.headers['Authorization'] = 'Bearer ' + token;
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

myAxios.interceptors.response.use(
    response => response,
    error => {
        // error.response chybí u síťových výpadků, timeoutů nebo zrušených
        // requestů (typicky mobilní síť) - v takovém případě není 401 řešitelné.
        if (error.response?.status === 401) {
            clearAuthData();
            axios.defaults.headers.common['Authorization'] = '';
            const isPublic = publicRoutes.includes(router.currentRoute.value.path);
            if (!isPublic) {
                void router.push('/login');
            }
        }
        return Promise.reject(error);
    }
);

window.http = myAxios;

initialize();
